import React, { useEffect, useRef, useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@ui/popover";

interface Props {
  trigger?: string | React.ReactNode;
  content: string | React.ReactNode;
  alignPosition?: "start" | "center" | "end";
  sidePosition?: "top" | "right" | "bottom" | "left";
  sideOffset?: number;
  open?: boolean;
  onOpenChange?: () => void;
}

const BasicPopover = React.forwardRef<HTMLDivElement, Props>(
  (
    {
      trigger,
      content,
      alignPosition,
      sidePosition,
      sideOffset,
      open,
      onOpenChange,
    },
    ref
  ) => {
    const [popoverWidth, setPopoverWidth] = useState("");
    const buttonRef = useRef<HTMLButtonElement>(null);

    useEffect(() => {
      if (buttonRef.current) {
        setPopoverWidth(`w-[${buttonRef.current.offsetWidth}px]`);
      }
    }, []);

    return (
      <Popover open={open}>
        <PopoverTrigger ref={buttonRef} onClick={onOpenChange} asChild>
          {trigger}
        </PopoverTrigger>
        <PopoverContent
          ref={ref}
          align={alignPosition}
          side={sidePosition}
          className={`bg-white dark:bg-black ${popoverWidth}`}
          sideOffset={sideOffset}
        >
          {content}
        </PopoverContent>
      </Popover>
    );
  }
);
export default BasicPopover;
